import { Config } from './config.interface';
import { localConfig } from './local.config';
import { developConfig } from './develop.config';
import { stagingConfig } from './staging.config';
import { productionConfig } from './production.config';
import { Environment, environment } from '@repo/environment';

let clientConfig: Config;

switch (environment) {
  case Environment.PRODUCTION:
    clientConfig = productionConfig;
    break;
  case Environment.DEVELOPMENT:
    clientConfig = developConfig;
    break;
  case Environment.LOCAL:
  case Environment.TEST:
    clientConfig = localConfig;
    break;
  default:
    clientConfig = stagingConfig;
}

export default clientConfig;
